import * as Sentry from "@sentry/vue"

Sentry.init({
    dsn: "https://a50b1b301d3ce640acc57f9aedd296e6@o364658.ingest.sentry.io/4506483223166976",
    enabled: import.meta.env.PROD
});
